import React from "react";
import StateInterpolator from "../components/StateInterpolator";

function Content(props) {
  const { client, savedStates } = props;

  if (savedStates.length === 2) {
    return (
      <StateInterpolator
        client={client}
        initialState={savedStates[0]}
        finalState={savedStates[1]}
      />
    );
  } else {
    return <React.Fragment />;
  }
}

export default Content;



// WEBPACK FOOTER //
// ./src/sections/data/subsections/Interpolator.js